export default {"src":"/_next/static/image/public/assets/platform-logos/google-docs.64c0857b85ca41289f9e79b533102004.svg","height":9673,"width":6994};